<template>
  <p class="lib__text-small lib__text-left lib__text-gray-500">
    {{ $t('priceDisclaimer.information') }}{{ '&nbsp;' }}
    <sup class="lib__tooltips" @click="openPackageDisclaimerModal">
      <span class="lib__tooltips__trigger">
        <i class="fas fa-info"></i>
      </span>
    </sup>
    <modal-dialog :closeable="$t('common.close')" :open.sync="isPackageDisclaimerModalOpen" :size="'medium'">
      <p v-html="$t('priceDisclaimer.modal')"></p>
    </modal-dialog>
  </p>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'price-disclaimer'
})
export default class PriceDisclaimer extends Vue {
  public isPackageDisclaimerModalOpen: boolean = false
  public openPackageDisclaimerModal() {
    this.isPackageDisclaimerModalOpen = true
  }
}
</script>